import React, { Component } from "react";
import Zmage from "react-zmage";
import Fade from "react-reveal";
import img1 from "..//portfolio//amanita1.png";
import img2 from "..//portfolio//amanita2.png";
import img3 from "..//portfolio//amanita3.png";
import img4 from "..//portfolio//amanita4.png";
import img5 from "..//portfolio//amanita5.png";
import img6 from "..//portfolio//pennybun1.png";
import img7 from "..//portfolio//pennybun2.png";
import img8 from "..//portfolio//pennybun3.png";
import img9 from "..//portfolio//pennybun4.png";
import img10 from "..//portfolio//pennybun5.png";

import img11 from "..//portfolio//Amanita39.jpg";
import img21 from "..//portfolio//Amanita17.jpg";
import img31 from "..//portfolio//Amanita14.jpg";
import img41 from "..//portfolio//Amanita13.jpg";
import img51 from "..//portfolio//Amanita12.jpg";
import img61 from "..//portfolio//Penny Bun6.jpg";
import img71 from "..//portfolio//Penny Bun4.jpg";
import img81 from "..//portfolio//Penny Bun8.jpg";
import img91 from "..//portfolio//Penny Bun13.jpg";
import img101 from "..//portfolio//Penny Bun18.jpg";

let id = 0;
class Portfolio extends Component {
  render() {
    if (!this.props.data) return null;

    const projects = this.props.data.projects.map(function (projects) {
      let projectImage = "images/portfolio/" + projects.image;

      return (
        <div key={id++} className="columns portfolio-item">
          <div className="item-wrap">
            <Zmage alt={projects.title} src={projectImage} />
            <div style={{ textAlign: "center" }}>{projects.title}</div>
          </div>
        </div>
      );
    });
    function swap() {
      document.getElementById("one").src = img1;
      document.getElementById("two").src = img2;
      document.getElementById("three").src = img3;
      document.getElementById("four").src = img4;
      document.getElementById("five").src = img5;
      document.getElementById("six").src = img6;
      document.getElementById("seven").src = img7;
      document.getElementById("eight").src = img8;
      document.getElementById("nine").src = img9;
      document.getElementById("ten").src = img10;
    }
    return (
      <section id="portfolio">
        <Fade left duration={1000} distance="40px">
          <div className="row">
            <div className="twelve columns collapsed">
              <h1>Here is a result.</h1>
              <img id="one" src={img11}></img>
              <img id="two" src={img21}></img>
              <img id="three" src={img31}></img>
              <img id="four" src={img41}></img>
              <img id="five" src={img51}></img>
              <img id="six" src={img61}></img>
              <img id="seven" src={img71}></img>
              <img id="eight" src={img81}></img>
              <img id="nine" src={img91}></img>
              <img id="ten" src={img101}></img>
              <button onClick={swap} className="m-5">Shroomnify</button>
              <div
                id="portfolio-wrapper"
                className="bgrid-quarters s-bgrid-thirds cf"
              >

              </div>
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

export default Portfolio;
